/*
 * Copyright (C) 2019 Robert Bosch GmbH Copyright (C) 2019 Robert Bosch Manufacturing Solutions GmbH, Germany. All rights reserved.
 */

import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { MatDialogModule } from "@angular/material/dialog";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatIconModule } from "@angular/material/icon";
import { MatListModule } from "@angular/material/list";
import { MatSelectModule } from "@angular/material/select";
import { MatTableModule } from "@angular/material/table";
import { MatProgressBarModule } from "@angular/material/progress-bar";

import { BciSharedModule } from "../shared/shared.module";
import { AlertDialogComponent } from "./alert/alert-dialog/alert-dialog.component";
import { BciMessagesFilterComponent } from "./messages/bci-messages-filter/bci-messages-filter.component";
import { BciMessagesComponent } from "./messages/bci-messages.component";
import { ModalComponent } from "./modal-window/modal.component";
import { LoadingScreenComponent } from "./loading-screen/loading-screen.component";
import { BciActivityIndicatorComponent } from "./layout/bci-activity-indicator/activity-indicator.component";

@NgModule({
    imports: [
        CommonModule,
        /* Angular Material*/
        MatDialogModule,
        MatButtonModule,
        MatIconModule,
        MatTableModule,
        MatListModule,
        MatSelectModule,
        MatExpansionModule,
        MatProgressBarModule,
        /* */
        BciSharedModule
    ],
    declarations: [
        AlertDialogComponent,
        BciMessagesComponent,
        BciMessagesFilterComponent,
        ModalComponent,
        LoadingScreenComponent,
        BciActivityIndicatorComponent
    ],
    exports: [
        AlertDialogComponent,
        BciMessagesComponent,
        ModalComponent,
        LoadingScreenComponent,
        BciActivityIndicatorComponent
    ]
})
export class BciComponentModule {}
